import { LazyMotion, domAnimation } from 'motion/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { SmoothScroll } from '@/components/smooth-scroll'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* domAnimation covers everything this site uses (animate/exit/variants,
        AnimatePresence, spring values) without the drag-gesture and layout-
        animation code neither this site nor any of its components touch --
        that's what Lighthouse's "reduce unused JavaScript" flagged
        (VisualElementDragControls, create-projection-node). `strict` makes a
        stray `motion.*` (instead of `m.*`) throw immediately instead of
        silently pulling the full bundle back in. */}
    <LazyMotion features={domAnimation} strict>
      <BrowserRouter>
        <SmoothScroll>
          <App />
        </SmoothScroll>
      </BrowserRouter>
    </LazyMotion>
  </StrictMode>,
)
